import React, { Component } from "react";
import { TextField, List, ListItem, ListItemText } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import classNames from 'classnames';
import firebase from "./../firebase";
import { getDatabase,onValue, ref, orderByChild, equalTo, get, set, child, update,query,push,remove } from "firebase/database";
import moment from 'moment'; 
import $ from 'jquery';

class Chatcomp extends Component {
    constructor(props) {
      super(props)
      this.state = { 
        count_logs: 0,
        myip: '',
        mylocation: '',
        text: "", 
        messages: [], 
        btnsubmit: true 
      }
    }
    componentDidMount() {
      this.logs()
      this.getMessages()
    }
  
    logs = () => {
      //alert('Did Logs');
      //firebase.database().ref("/logs").on('value', snapshot => {
      const db = getDatabase();
      get(ref(db,"logs")).then((snapshot)=>{
        var select_logs = []
        snapshot.forEach(child => {
          var data = child.val()
          select_logs.push({
              id: data.id,
              status: data.status,
              message: data.message,
              agent: data.agent,
              ip: data.ip,
              location: data.location,
              user_id: data.user_id,
              time: data.time,
            })
        this.setState({ count_logs: select_logs.length })
        
        })
      })
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((data) => {
          //alert(JSON.stringify(data.ip))
            setTimeout(function(){ 
              this.setState({ myip: data.ip, mylocation: data.country_name+'#'+data.region })
            }.bind(this), 200);
  
      setTimeout(function(){ 
      //alert(JSON.stringify(this.state.count_logs));
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      /*var refdb = firebase.database().ref('/logs').push();
      refdb = refdb.toString().slice(-20);
      
      let updateData = firebase.database().ref("/logs").child(refdb);
      updateData.child("id").set(this.state.count_logs+1);
      updateData.child("status").set('1');
      updateData.child("message").set('User Access Chat Page');
      updateData.child("agent").set(navigator.userAgent);
      updateData.child("ip").set(this.state.myip);
      updateData.child("location").set(this.state.mylocation);
      updateData.child("user_id").set(localStorage.getItem('user_id'));
      updateData.child("time").set(curtime);*/
      var refdb = push(ref(db,'/logs'));
      //refdb_ref = refdb.toString().slice(-20);
      
      fetch('https://ipapi.co/json')
        .then(res => res.json())
        .then((dataipres) => {
          //let updateData = ref(db,"logs/"+refdb);
          set(refdb,{
            id:this.state.count_logs+1,
            status:'1',
            message:'User Access Chat Page',
            agent:String(navigator.userAgent),
            ip: String(dataipres.ip),
            location:String(dataipres.country_name+'#'+dataipres.region),
            user_id:String(localStorage.getItem('user_id')),
            time:String(curtime)
          });
      });
      }.bind(this), 400);
    })

    }

    onSubmit = event => {
      if (event.charCode === 13 && this.state.text.trim() !== "") {
        this.writeMessageToDB(this.state.text)
        this.setState({ text: "" })
      }
    }

    onSubmitbtn = () => {
      alert(this.state.text);
      alert('S-a facut!!');
      //this.setState({ btnsubmit: true });
      alert(this.state.btnsubmit);
      if( this.state.btnsubmit ){
        this.writeMessageToDB(this.state.text);
        this.setState({ text: "" });
        this.getMessages();
        //this.refs.divmessage.scrollTop = this.refs.divmessage.scrollHeight;
        //alert(this.refs.divmessage.scrollTop);
        //alert(this.refs.divmessage.scrollHeight);
        this.setState({ btnsubmit: false });
        setTimeout(function(){
        $('#divmsg').scrollTop($('#divmsg')[0].scrollHeight);
        }, 2000);
      }
    }
  
    writeMessageToDB = message => {
      var curtime = moment().format("DD/MM/YYYY HH:mm:ss");
      //alert(curtime);
      /*firebase
        .database()
        .ref("/messages")
        .push({
          text: message,
          time: curtime,
          userid: localStorage.getItem('user_id')
        })*/
        const db = getDatabase();
        var refdb = push(ref(db,'messages'));
        set(refdb,{
          text: message,
          time: curtime,
          userid: localStorage.getItem('user_id')
        });
    }
  
    getMessages = () => {
      //alert(this.state.messages)
      /*var messagesDB = firebase
        .database()
        .ref("/messages")
        .limitToLast(500)
      messagesDB.on("value", snapshot => {*/
      const db = getDatabase();
      get(ref(db,"messages")).then((snapshot)=>{
        let newMessages = []
        snapshot.forEach(child => {
          var message = child.val()
          newMessages.push({ id: child.key, text: message.text,time: message.time,userid: message.userid })
        })
        this.setState({ messages: newMessages })
        //alert(this.state.messages)
        $('#divmsg').scrollTop($('#divmsg')[0].scrollHeight);
        this.bottomSpan.scrollIntoView({ behavior: "smooth" })
      })
    }
  
    renderMessages = () => {
      return this.state.messages.map(message => (
        <ListItem>
          <ListItemText
          primary={message.userid}
          />
          <ListItemText
            className="ListItemText message"
            style={{ wordBreak: "break-word"}}
            secondary={message.time}
            primary={message.text}
          />
        </ListItem>
      ))
    }
  
    render() {
      const divStyle={
        overflowY: 'scroll',
        border:'1px solid red',
        float: 'left',
        height:'500px',
        position:'relative'
      };
      return (
        <div className="Chat">
          <div className="col-12" id="divmsg" style={divStyle}><List>{this.renderMessages()}</List></div>
          <FormControl margin="normal" required fullWidth>
                    <InputLabel htmlFor="textsend">Message</InputLabel>
          <Input
            autoFocus={true}
            multiline={true}
            name="textsend"
            rowsMax={3}
            onChange={event => this.setState({ text: event.target.value })}
            value={this.state.text}
            onKeyPress={this.onSubmit}
          />
          </FormControl>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => { this.setState({ btnsubmit: true });alert('S-a facut!!!');this.onSubmitbtn() }}
          >
          <Icon className={classNames('fa fa-paper-plane')} />&nbsp;&nbsp;Send
          </Button>
          <span ref={el => (this.bottomSpan = el)} />
        </div>
      )
    }
  }
  
  export default Chatcomp